import React from "react";
import { APP_PREFIX_PATH } from "configs/AppConfig";

export const rewardLogsRoutes = [
	{
		key: "reward-payment-status-logs",
		exact: true,
		path: `${APP_PREFIX_PATH}/reward/logs/payment-status`,
		component: React.lazy(() => import("views/reward-views/logs/payment-logs/pages/PaymentStatusLogger")),
	},
	{
		key: "reward-invoice-logs",
		exact: true,
		path: `${APP_PREFIX_PATH}/reward/logs/invoice-sync`,
		component: React.lazy(() => import("views/reward-views/logs/invoice-sync/pages/InvoiceSyncLogger")),
	},
];
